//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/StatusCode.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/StatusCode.proto.
 */
export const file_android_hardware_automotive_vehicle_StatusCode: GenFile = /*@__PURE__*/
  fileDesc("CjRhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9TdGF0dXNDb2RlLnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byJiChRWZWhpY2xlSGFsQ2FsbFN0YXR1cxJKCgtzdGF0dXNfY29kZRgBIAEoDjI1LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlN0YXR1c0NvZGUqggIKClN0YXR1c0NvZGUSBgoCT0sQABINCglUUllfQUdBSU4QARIPCgtJTlZBTElEX0FSRxACEhEKDU5PVF9BVkFJTEFCTEUQAxIRCg1BQ0NFU1NfREVOSUVEEAQSEgoOSU5URVJOQUxfRVJST1IQBRIaChZOT1RfQVZBSUxBQkxFX0RJU0FCTEVEEAYSGwoXTk9UX0FWQUlMQUJMRV9TUEVFRF9MT1cQBxIcChhOT1RfQVZBSUxBQkxFX1NQRUVEX0hJR0gQCBIhCh1OT1RfQVZBSUxBQkxFX1BPT1JfVklTSUJJTElUWRAJEhgKFE5PVF9BVkFJTEFCTEVfU0FGRVRZEApiBnByb3RvMw");

/**
 * @generated from message android.hardware.automotive.vehicle.proto.VehicleHalCallStatus
 */
export type VehicleHalCallStatus = Message<"android.hardware.automotive.vehicle.proto.VehicleHalCallStatus"> & {
  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.StatusCode status_code = 1;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehicleHalCallStatus.
 * Use `create(VehicleHalCallStatusSchema)` to create a new message.
 */
export const VehicleHalCallStatusSchema: GenMessage<VehicleHalCallStatus> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_StatusCode, 0);

/**
 * Must be in sync with StatusCode.aidl. 
 *
 * @generated from enum android.hardware.automotive.vehicle.proto.StatusCode
 */
export enum StatusCode {
  /**
   * @generated from enum value: OK = 0;
   */
  OK = 0,

  /**
   * Try again. 
   *
   * @generated from enum value: TRY_AGAIN = 1;
   */
  TRY_AGAIN = 1,

  /**
   * Invalid argument provided. 
   *
   * @generated from enum value: INVALID_ARG = 2;
   */
  INVALID_ARG = 2,

  /**
   * This code must be returned when device that associated with the vehicle
   * property is not available. For example, when client tries to set HVAC
   * temperature when the whole HVAC unit is turned OFF. 
   *
   * @generated from enum value: NOT_AVAILABLE = 3;
   */
  NOT_AVAILABLE = 3,

  /**
   * Access denied 
   *
   * @generated from enum value: ACCESS_DENIED = 4;
   */
  ACCESS_DENIED = 4,

  /**
   * Something unexpected has happened in Vehicle HAL 
   *
   * @generated from enum value: INTERNAL_ERROR = 5;
   */
  INTERNAL_ERROR = 5,

  /**
   * *
   * For features that are not available because the underlying feature is
   * disabled.
   *
   * @generated from enum value: NOT_AVAILABLE_DISABLED = 6;
   */
  NOT_AVAILABLE_DISABLED = 6,

  /**
   * *
   * For features that are not available because the vehicle speed is too low.
   *
   * @generated from enum value: NOT_AVAILABLE_SPEED_LOW = 7;
   */
  NOT_AVAILABLE_SPEED_LOW = 7,

  /**
   * *
   * For features that are not available because the vehicle speed is too
   * high.
   *
   * @generated from enum value: NOT_AVAILABLE_SPEED_HIGH = 8;
   */
  NOT_AVAILABLE_SPEED_HIGH = 8,

  /**
   * *
   * For features that are not available because of bad camera or sensor
   * visibility. Examples might be bird poop blocking the camera or a bumper
   * cover blocking an ultrasonic sensor.
   *
   * @generated from enum value: NOT_AVAILABLE_POOR_VISIBILITY = 9;
   */
  NOT_AVAILABLE_POOR_VISIBILITY = 9,

  /**
   * *
   * The feature cannot be accessed due to safety reasons. Eg. System could be
   * in a faulty state, an object or person could be blocking the requested
   * operation such as closing a trunk door, etc.
   *
   * @generated from enum value: NOT_AVAILABLE_SAFETY = 10;
   */
  NOT_AVAILABLE_SAFETY = 10,
}

/**
 * Describes the enum android.hardware.automotive.vehicle.proto.StatusCode.
 */
export const StatusCodeSchema: GenEnum<StatusCode> = /*@__PURE__*/
  enumDesc(file_android_hardware_automotive_vehicle_StatusCode, 0);

